import { createRouter, createWebHistory } from 'vue-router'; // Import from 'vue-router'
import Home from '../views/Home.vue';
import Explore from '../views/Explore.vue';
import Culture from '../views/Culture.vue';
import Stories from '../views/Stories.vue';
import Article from '../views/Article.vue';
import Search from '../views/Search.vue';

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/explore', name: 'Explore', component: Explore },
  { path: '/culture', name: 'Culture', component: Culture },
  { path: '/stories', name: 'Stories', component: Stories },
  {
    path: '/:section/:id',
    name: 'Article',
    component: Article,
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
  },
];

const router = createRouter({
  history: createWebHistory(), // Use createWebHashHistory for hash mode
  routes,
});

export default router;